var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "push-info-container"
  }, [_vm.loading ? _c('Loading') : _vm._e(), !_vm.error ? _c('LineOaButton') : _vm._e(), _vm.error ? _c('div', {
    staticClass: "error-message"
  }, [_c('b-icon', {
    attrs: {
      "icon": "exclamation-circle",
      "variant": "danger",
      "font-scale": "3"
    }
  }), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v(_vm._s(_vm.errorMessage))])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }